import fetch from 'auth/FetchInterceptor'
import { API_BASE_URL } from 'configs/AppConfig'

const GamificationService = {}

const jsonHeaders = { 'Content-Type': 'application/json' }

const requestOptions = options => options?.silent ? { suppressErrorNotification: true } : {}

GamificationService.list = (resource, params, options) => fetch({ url: `/${resource}`, method: 'get', params, ...requestOptions(options) })
GamificationService.get = (resource, id, options) => fetch({ url: `/${resource}/${id}`, method: 'get', ...requestOptions(options) })
GamificationService.create = (resource, data) => fetch({ url: `/${resource}`, method: 'post', headers: jsonHeaders, data })
GamificationService.update = (resource, id, data) => fetch({ url: `/${resource}/${id}`, method: 'patch', headers: jsonHeaders, data })
GamificationService.remove = (resource, id) => fetch({ url: `/${resource}/${id}`, method: 'delete' })
GamificationService.changeOwnPassword = (data) => fetch({ url: '/users/me/change-password', method: 'post', headers: jsonHeaders, data })
GamificationService.resetUserPassword = (id, newPassword) => fetch({ url: `/users/${id}/reset-password`, method: 'post', headers: jsonHeaders, data: { newPassword } })
GamificationService.publishVersion = (id) => fetch({ url: `/game-versions/${id}/publish`, method: 'post' })
GamificationService.markVersionAsUploaded = (id) => fetch({ url: `/game-versions/${id}`, method: 'patch', headers: jsonHeaders, data: { status: 'uploaded' } })
GamificationService.createPreviewToken = (id) => fetch({ url: `/game-versions/${id}/preview-token`, method: 'post' })
GamificationService.submitVersionForReview = (id) => fetch({ url: `/game-versions/${id}/submit-review`, method: 'post' })
GamificationService.approveVersionReview = (id) => fetch({ url: `/game-versions/${id}/approve-review`, method: 'post' })
GamificationService.promoteVersionToProduction = (id) => fetch({ url: `/game-versions/${id}/promote`, method: 'post' })
GamificationService.importVersionConfig = (id, file) => {
  const data = new FormData()
  data.append('file', file)
  return fetch({ url: `/game-versions/${id}/config`, method: 'post', data })
}
GamificationService.uploadAssetFile = ({ campaignId, campaignCode, versionId, versionName, kind, file }) => {
  const data = new FormData()
  data.append('file', file)
  data.append('campaignId', campaignId)
  data.append('campaignCode', campaignCode || campaignId)
  data.append('versionId', versionId)
  data.append('versionName', versionName || versionId)
  data.append('kind', kind)
  return fetch({ url: '/assets/upload', method: 'post', data })
}
GamificationService.uploadImage = ({ file, folder = 'images', campaignId }) => {
  const data = new FormData()
  data.append('file', file)
  data.append('folder', folder)
  if (campaignId) data.append('campaignId', campaignId)
  return fetch({ url: '/assets/image-upload', method: 'post', data }).then(result => ({
    ...result,
    url: result?.url?.startsWith('/uploads/') ? `${API_BASE_URL.replace(/\/api\/v1\/?$/, '')}${result.url}` : result?.url,
  }))
}
GamificationService.summary = (params, options) => fetch({ url: '/reports/summary', method: 'get', params, ...requestOptions(options) })
GamificationService.campaignOverview = (params, options) => fetch({ url: '/reports/campaign-overview', method: 'get', params, ...requestOptions(options) })
GamificationService.leaderboard = (params, options) => fetch({ url: '/reports/leaderboard', method: 'get', params, ...requestOptions(options) })
GamificationService.systemMetrics = (options) => fetch({ url: '/system-metrics', method: 'get', ...requestOptions(options) })

export default GamificationService
